import { css, keyframes } from 'styled-components';

export const DURATION = {
  fast: '200ms',
  base: '400ms',
  slow: '600ms'
} as const;

export const EASING = {
  entrance: 'cubic-bezier(0.16, 1, 0.3, 1)',
  exit: 'cubic-bezier(0.4, 0, 1, 1)',
  standard: 'cubic-bezier(0.4, 0, 0.2, 1)'
} as const;

export type MotionDuration = keyof typeof DURATION;

export const panelTransition = ({
  properties = [],
  duration = 'base'
}: {
  properties?: string[];
  duration?: MotionDuration;
} = {}) => css`
  transition: ${['opacity', ...properties]
    .map((property) => `${property} ${DURATION[duration]} ${EASING.entrance}`)
    .join(', ')};

  @media (prefers-reduced-motion: reduce) {
    transition: opacity ${DURATION.fast} linear;
  }
`;

const fadeInFrames = keyframes`
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: none;
  }
`;

export const fadeInContent = (duration: MotionDuration = 'base') => css`
  animation: ${fadeInFrames} ${DURATION[duration]} ${EASING.entrance} both;

  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;
